module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/extract.worker.4baf549d.worker.js");
}
